import { type PropsWithChildren } from 'react';

import { labelsContainer } from './GaugeLabelsWrapper.sty.js';
import { useGaugeChartAspectRatio } from '../../hooks/useGaugeChartAspectRatio.js';

export const GaugeLabelsWrapper = ({ children }: PropsWithChildren) => {
  const { arcInnerRadius } = useGaugeChartAspectRatio();

  // Formula to calculate the maximum square inside a circle =  √2 × radius
  const availableWidth = Math.sqrt(2) * arcInnerRadius;
  const availableHeight = (2 * availableWidth) / 3;

  const translateX = -availableWidth / 2;
  const translateY = (-2 * availableHeight) / 3;

  return (
    <foreignObject
      width={availableWidth}
      height={availableHeight}
      transform={`translate(${translateX}, ${translateY})`}
    >
      <div className={labelsContainer}>{children}</div>
    </foreignObject>
  );
};
